import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class SectorService extends ServiceCRUD {
  constructor() {
    super('/api/voicemail');
  }
}

export default new SectorService();
